import React from "react";
import { Card, CardContent, CardHeader, Typography, Tooltip as Tool } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { Axis, Chart, Geom, Tooltip } from "bizcharts";
import { tooltips } from "../../constants/tooltips";
import { colours } from "../../utilities/styles";

const formatTrainingSessionAxis = (value: string) => {
  if (value === "1" || value === "0") {
    return `${value}`;
  }
  return `${value}`;
};
const formatActiveUserAxis = (value: any) => {
  if (value === "1") {
    return `${value} member`;
  }
  return `${value} members`;
};

const DashboardTrendChart = (props: {
  weekly_trend: Array<{
    year: number;
    week: number;
    training_sessions: number;
    active_users: number;
  }>;
}) => {
  const weekly_trend = props.weekly_trend.map((e) => ({
    ...e,
    index: e.year * 100 + e.week,
  }));
  weekly_trend.sort((a, b) => a.index - b.index);
  const data = weekly_trend;
  data.forEach((e, i) => (e.index = i));
  /**
   * https://github.com/alibaba/BizCharts/blob/master/doc/api/scale.md
   */
  const makeScale = (tickCount: number) => {
    return {
      index: {
        alias: "Index",
        formatter: function (index: number) {
          return `W${data[index].week}`;
        },
        type: "linear",
        nice: false,
        tickCount: Math.max(2, tickCount),
      },
      training_sessions: {
        alias: "Average self-rate",
        min: 0,
        max: 10,
      },
      active_users: {
        alias: "Weekly reflections",
        min: 0,
        tickCount: Math.max(2, tickCount),
        tickInterval: 10,
      },
    };
  };

  return (
    <Card>
      <CardHeader
        title={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              padding: "8px 0 30px 20px",
            }}
          >
            <Typography variant="h6">Weekly reflection: My leadership this week</Typography>
            <Tool title={<Typography>{tooltips.weeklyTrend}</Typography>} aria-label="weeklyTrend">
              <HelpOutlineIcon />
            </Tool>
          </div>
        }
        style={{ padding: "8px 8px 0 0" }}
      />
      <CardContent>
        <Chart
          placeholder="No data"
          height={300}
          padding={[30, 70, 30, 90]}
          forceFit={true}
          data={data}
          scale={makeScale(data.length)}
        >
          <Tooltip />

          <Axis name="training_sessions" label={{ formatter: formatTrainingSessionAxis }} />
          <Axis name="active_users" label={{ formatter: formatActiveUserAxis }} />
          <Geom
            type="line"
            position="index*training_sessions"
            color={colours.yomento_purple}
            size={2}
            shape="line"
          />
          <Geom
            type="line"
            position="index*active_users"
            color={colours.yomento_grey}
            size={2}
            shape="smooth"
          />
        </Chart>
      </CardContent>
    </Card>
  );
};

export default DashboardTrendChart;
